import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { API_KEY } from '../Requests';
import './VideoScreen.css';
const VideoScreen = () => {
    const { id } = useParams();
    const [details, setDetails] = useState({});
    useEffect(() => {
        fetch(`https://api.themoviedb.org/3/movie/${id}?api_key=${API_KEY}&append_to_response=videos`)
            .then(res => res.json())
            .then(data => setDetails(data))
    }, [id])
    console.log(details)
    return (
        <div className='videoscreen-style'>
            <iframe className='frame-style' width="80%" height="500" src={`https://www.youtube.com/embed/${details?.videos?.results[0].key}`} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            <h1 className='movie-title'>{details?.original_title}</h1>
        </div>
    );
};

export default VideoScreen;